import * as t from 'io-ts';

export const BookingModificationRequestDynamicType = t.interface({
    modificationRequest: t.string,
    user: t.string,
    dateSubmitted: t.string
});

export type BookingModificationRequest = t.TypeOf<typeof BookingModificationRequestDynamicType>;
